import React from 'react';
import { getPayrollWeekRangeLabel, renderPaidHours } from '../../utils/attendanceDateTime';

const SummaryMetric = ({ label, value }) => (
  <div className="rounded-md border border-[#3F3F46] bg-[#121212] p-4">
    <p className="text-[#A1A1AA] text-xs uppercase">{label}</p>
    <p className="text-white text-xl font-semibold mt-1">{value}</p>
  </div>
);

export default function PayrollSummaryCards({ venueName, weekStart, totals }) {
  return (
    <div className="card-rtb" data-testid="payroll-summary-cards">
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        <SummaryMetric label="Selected Venue" value={venueName || 'Select venue'} />
        <SummaryMetric label="Payroll Week" value={getPayrollWeekRangeLabel(weekStart)} />
        <SummaryMetric label="Venue Paid Hours" value={renderPaidHours(totals?.total_paid_hours || 0)} />
        <SummaryMetric label="Shifts / Staff" value={`${totals?.total_shifts || 0} / ${totals?.staff_count || 0}`} />
      </div>
    </div>
  );
}
